//#region src/js/components/modal.js
/**
* Modal component for handling dialog elements
* 
* @fileoverview Manages opening and closing of modal dialogs with CSS animations.
* The "closing" class is added during CSS fade in/fade out animations and then removed.
* This approach is necessary because the Dialog element needs to be "display: none" by default
* to prevent layout issues, and CSS transitions cannot work from display: none.
* 
* @module components/modal
* 
* @see {@link https://www.notion.so/bravetheskies/Modal-a24d96994cc84472976f052ac3619e9d|Modal Documentation}
* 
* @description
* Handles three main interactions:
* 1. Opening modals via elements with [data-modal-target] attribute
* 2. Closing modals via elements with [data-modal-close] attribute
* 3. Closing modals by clicking on the dialog backdrop
* 
* @todo Consolidate duplicate event listener logic into shared functions
* @todo Consider refactoring animation event listeners to reduce code duplication
*/
var targetModal = document.querySelectorAll("[data-modal-target]");
var closeModal = document.querySelectorAll("[data-modal-close]");
var modal = document.querySelectorAll("[data-modal]");
function closeDialogWithAnimation(dialog) {
	if (window.matchMedia("(max-width: 767px)").matches) {
		dialog.classList.add("closing");
		dialog.addEventListener("animationend", () => {
			dialog.classList.remove("closing");
			dialog.close();
		}, { once: true });
	} else dialog.close();
}
if (targetModal) {
	targetModal.forEach(function(element) {
		const target = element.getAttribute("data-modal-target");
		const targets = document.querySelectorAll(target);
		element.addEventListener("click", () => {
			targets.forEach(function(e) {
				e.showModal();
			});
		});
	});
	closeModal.forEach(function(element) {
		element.addEventListener("click", () => {
			closeDialogWithAnimation(element.closest("dialog"));
		});
	});
	modal.forEach(function(element) {
		element.addEventListener("click", (e) => {
			const dialog = element.closest("dialog");
			if (e.target === dialog) closeDialogWithAnimation(dialog);
		});
	});
}
//#endregion
